import { EyeClosedIcon, EyeOpenIcon } from "@/assets";
import {
  AsarDatePicker,
  AsarFormikInput,
  AsarFormikSelect,
} from "@/components";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { fields, styleLabel, universityYear } from "../../../utils";

export default function PersonalInfo() {
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const md = useMediaQuery("(max-width:450px)");

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        sx={{ width: "100%" }}
      >
        <Box display="flex" flexDirection={"row"} gap="10px">
          <Grid
            display={"flex"}
            flexDirection={"column"}
            sx={{ width: "120px" }}
          >
            <AsarFormikSelect
              label="جنسیت"
              name={"sex"}
              data={[
                {
                  id: "MALE",
                  label: "مرد",
                },
                {
                  id: "FEMALE",
                  label: "زن",
                },
              ]}
            />
          </Grid>

          <Grid
            display={"flex"}
            flexDirection={"column"}
            sx={{ width: "calc(100% - 90px)" }}
          >
            <AsarFormikInput
              label={"نام و نام خانوادگی"}
              name={"name"}
              placeholder="نام خود را کامل وارد نمایید."
            />
          </Grid>
        </Box>

        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <AsarFormikInput
            label={"نام پدر"}
            name={"fatherName"}
            placeholder="نام پدر خود را وارد نمایید."
          />

          <AsarFormikInput
            label="کد ملی"
            maxLength={10}
            inputMode="numeric"
            name="nid"
            placeholder="کد ملی خود را بنویسید."
          />
        </Grid>

        <AsarDatePicker
          label={"تاریخ تولد"}
          placeholder="تاریخ تولد خود را انتخاب کنید."
          name={"birthDay"}
        />
        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <AsarFormikInput
            label={"رمز عبور"}
            name={"password"}
            type={showPassword ? "text" : "password"}
            placeholder={"رمز عبور خود را بنویسید"}
            endAdornment={
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
              >
                {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
              </IconButton>
            }
          />

          <AsarFormikInput
            label={"تکرار رمزعبور"}
            name={"passwordRepeat"}
            type={showRepeatPassword ? "text" : "password"}
            placeholder={"تکرار رمزعبور خود را بنویسید"}
            endAdornment={
              <IconButton
                onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                edge="end"
                aria-label={showRepeatPassword ? "مخفی کردن رمز" : "نمایش رمز"}
              >
                {showRepeatPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
              </IconButton>
            }
          />
        </Grid>

        <AsarFormikInput
          label={"کد گروه"}
          maxLength={6}
          inputMode="numeric"
          name={"groupCode"}
          placeholder="کد گروه خود را بنویسید."
        />

        <Typography sx={styleLabel}>تحصیلات دانشجویی</Typography>
        <Box display="flex" gap="5px">
          <AsarFormikSelect
            name={"universityYear"}
            width={md ? "80px" : "120px"}
            data={universityYear}
            placeholder="سال"
          />
          <AsarFormikInput
            width={md ? "150px" : "190px"}
            name={"university"}
            placeholder="دانشگاه"
          />

          <AsarFormikSelect
            name={"field"}
            width={md ? "100px" : "140px"}
            data={fields}
            placeholder="رشته"
          />
        </Box>
      </Grid>
    </>
  );
}
